import { useState } from "react";
import axios from "axios";

export function useEvaluate({ grade = "VI", section = "A" }) {
  const [openModal, setOpenModal] = useState(false);
  const [examLoading, setExamLoading] = useState(false);
  const [examError, setExamError] = useState(false);
  const [examLink, setExamLink] = useState(null);
  const [selectedExamId, setSelectedExamId] = useState(null);

  const openExam = async (examId) => {
    setOpenModal(true);
    setExamLoading(true);
    setExamError(false);
    setExamLink(null);
    setSelectedExamId(examId);

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_ORIGIN}/api/v1/grades/${grade}/sections/${section}/exams/${examId}`,
        {
          headers: {
            token: window.localStorage.getItem("authToken"),
          },
        }
      );

      setExamLink(res.data?.link);
    } catch (err) {
      console.error(err);
      setExamError(true);
    } finally {
      setExamLoading(false);
    }
  };

  const closeExam = () => {
    setOpenModal(false);
    setExamLink(null);
    setExamError(false);
  };

  return {
    openModal,
    examLoading,
    examError,
    examLink,
    selectedExamId,
    openExam,
    closeExam,
  };
}